// extracted by mini-css-extract-plugin
export default {"wrapper":"OtpInput_wrapper__xxiwK","typing":"OtpInput_typing__iNk10","verifying":"OtpInput_verifying__yxGtj","verified":"OtpInput_verified__q9hms","error":"OtpInput_error__MxlVd"};